import { Component } from 'react'
import { Box, Button, Title } from 'rbx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

// Fronteira de erro reutilizável e de escopo LOCAL: envolva o conteúdo de uma tela
// (ou de um bloco arriscado dentro dela) para que uma exceção de render derrube só
// aquele pedaço, com aviso visível, em vez de desmontar a árvore inteira e deixar a
// tela branca. Em React 17 class component é a única forma de implementar isto —
// não existe equivalente em hooks.
//
// Deliberadamente NÃO aplicado globalmente em routes.js: a estratégia global de
// tratamento de erro segue como decisão de ADR em aberto. Este componente existe
// para que essa decisão continue viável sem reescrita.
//
// Uso:
//   <ErrorBoundary title="..." description="..." onReset={() => refetch()}>
//     <ConteudoQuePodeQuebrar />
//   </ErrorBoundary>
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
    this.handleReset = this.handleReset.bind(this)
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, errorInfo) {
    // Sem serviço de observabilidade no projeto: o console é o único destino
    // disponível hoje. Trocar por um reporter real quando existir um.
    console.error('[ErrorBoundary] erro capturado:', error, errorInfo)

    if (typeof this.props.onError === 'function') {
      this.props.onError(error, errorInfo)
    }
  }

  handleReset() {
    this.setState({ error: null })

    if (typeof this.props.onReset === 'function') {
      this.props.onReset()
    }
  }

  render() {
    const {
      children,
      title = 'Não foi possível exibir esta seção',
      description = 'Ocorreu um erro inesperado ao carregar o conteúdo. Tente novamente ou recarregue a página.',
      resetLabel = 'Tentar novamente'
    } = this.props

    if (!this.state.error) return children

    return (
      <Box
        role="alert"
        style={{
          margin: '2rem auto',
          maxWidth: '32rem',
          textAlign: 'center',
          // --text-title (#363f5f) e não --text-body (#969cb3): o token de corpo
          // rende ~2.5:1 sobre branco e reprova no piso WCAG AA de 4.5:1.
          color: 'var(--text-title)'
        }}
      >
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          style={{ color: 'var(--red)', fontSize: '2rem' }}
          aria-hidden="true"
        />

        <Title size={5} style={{ color: 'var(--text-title)', marginTop: '1rem' }}>
          {title}
        </Title>

        <p style={{ color: 'var(--text-title)', marginBottom: '1.5rem' }}>
          {description}
        </p>

        <Button type="button" color="info" onClick={this.handleReset}>
          {resetLabel}
        </Button>
      </Box>
    )
  }
}

export default ErrorBoundary
